var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("JetFormEditorRow", { attrs: { label: _vm.labels.countries } }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.response.countries,
                expression: "response.countries",
              },
            ],
            attrs: { multiple: "", size: "10" },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.response,
                  "countries",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          _vm._l(_vm.countriesList, function ({ label, value }) {
            return _c("option", { domProps: { value: value } }, [
              _vm._v(_vm._s(label)),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "JetFormEditorRow",
        {
          attrs: { label: _vm.labels.types },
          scopedSlots: _vm._u([
            {
              key: "helpLabel",
              fn: function () {
                return [
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.help.types_link_label) + "\n\t\t\t"
                  ),
                  _c("a", { attrs: { href: _vm.help.types_link } }, [
                    _vm._v(_vm._s(_vm.help.types_link_name)),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.response.types,
                  expression: "response.types",
                },
              ],
              attrs: { multiple: "", size: "5" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.response,
                    "types",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            _vm._l(_vm.types, function ({ label, value }) {
              return _c("option", { domProps: { value: value } }, [
                _vm._v(_vm._s(label)),
              ])
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }